import React from 'react';
import '../Estilos/Estilo.scss';

class NewsBoard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      noticias: [],
      eventos: [],
      ofertas: [],
      offersFintrade: [],
      notasPrensa: [],
      loadingNews: true,
      loadingEvents: true,
      loadingOffers: true,
      loadingPressNotes: true,
      loading: true,
      infoFiltrada: [],
      totalTarjetas: props.total,
    };
  }

  componentDidMount() {
    fetch(process.env.PUBLIC_URL + "/assets/json/news.json").then(res => res.json()).then(noticias => this.setState({ noticias, loadingNews: false }));
    fetch(process.env.PUBLIC_URL + "/assets/json/events.json").then(res => res.json()).then(eventos => this.setState({ eventos, loadingEvents: false }));
    fetch(process.env.PUBLIC_URL + "/assets/json/offers.json").then(res => res.json()).then(ofertas => this.setState({ ofertas, loadingOffers: false }));
    fetch(process.env.PUBLIC_URL + "/assets/json/press-notes.json").then(res => res.json()).then(notasPrensa => this.setState({ notasPrensa, loadingPressNotes: false }));
  }

  filtarOfertas = () => {
    var fecha = new Date(Date.now());
    const filteredOfertas = this.state.ofertas.filter(({ limitDate }) => {
      return new Date(limitDate.concat('T23:59:59')) >= fecha;
    });
    const aux = [...filteredOfertas].map(({ title, limitDate, link, description, publicationDate }) => {
      return { title, limitDate, link, description, publicationDate };
    });
    this.setState({ offersFintrade: aux })
  }
  setData = () => {
    var numTarjetas = 0;
    var tipo = 0;
    var elemento = [0, 0, 0, 0];
    var final = [false, false, false, false];

    this.filtarOfertas();

    this.setState({ infoFiltrada: [] });


    while (numTarjetas < this.state.totalTarjetas && !(final[0] && final[1] && final[2] && final[3])) {
      switch (tipo) {
        case 0:
          this.state.infoFiltrada.push({ 'type': 'news', 'data': this.state.noticias.slice(elemento[tipo], elemento[tipo] + 1) });
          if (this.state.noticias.slice(elemento[tipo], elemento[tipo] + 1).length > 0) {
            numTarjetas++;
            elemento[tipo]++;
          } else {
            final[tipo] = true;
          }
          tipo++;
          break;
        case 1:
          this.state.infoFiltrada.push({ 'type': 'events', 'data': this.state.eventos.slice(elemento[tipo], elemento[tipo] + 1) });
          if (this.state.eventos.slice(elemento[tipo], elemento[tipo] + 1).length > 0) {
            numTarjetas++;
            elemento[tipo]++;
          } else {
            final[tipo] = true;
          }
          tipo++;
          break;
        case 2:
          this.state.infoFiltrada.push({ 'type': 'offers', 'data': this.state.offersFintrade.slice(elemento[tipo], elemento[tipo] + 1) });
          if (this.state.offersFintrade.slice(elemento[tipo], elemento[tipo] + 1).length > 0) {
            numTarjetas++;
            elemento[tipo]++;
          } else {
            final[tipo] = true;
          }
          tipo++;
          break;
        case 3:
          this.state.infoFiltrada.push({ 'type': 'pressNotes', 'data': this.state.notasPrensa.slice(elemento[tipo], elemento[tipo] + 1) });
          if (this.state.notasPrensa.slice(elemento[tipo], elemento[tipo] + 1).length > 0) {
            numTarjetas++;
            elemento[tipo]++;
          } else {
            final[tipo] = true;
          }
          tipo = 0;
          break;
        default:
          break;

      }

    }
    this.setState({ loading: false });
  }

  getCaracteresCuerpoPrincipal ( titulo, tieneFechaExtra) {
    var alturaTotal;
    if(tieneFechaExtra)
      alturaTotal = 222;
    else
      alturaTotal = 250;
    var caracteres = 0;
    var texto = titulo.title; 
    var filasTitulo = Math.ceil((texto.length/ 35)+1);
    var alturaCuerpoPx = alturaTotal - (filasTitulo*1.75*16);
    var FilasCuerpoReal = (alturaCuerpoPx/(16*0.875+16))-1;
    var FilasCuerpo = Math.ceil(FilasCuerpoReal);
    caracteres = FilasCuerpo * 40;
    console.log("filas titulo: ");
    console.log(titulo);
    console.log(filasTitulo);
    return caracteres;
  }

  render() {
    return (
      <div>
        {this.state.loadingEvents || this.state.loadingNews || this.state.loadingOffers || this.state.loadingPressNotes ? '' :
          this.setData()}
        {this.state.loading ? '' :
          <div className='container'>

            {this.state.infoFiltrada.map(({ type, data }) => {
              return (
                <div>
                  {type === 'news' ? data.map(({ title, introduction, link, publicationDate }) => {
                    return (
                      <a href='./news' style={{ textDecoration: 'none' }} >
                        <div class='tablon-card' on >
                          <div className="tipo news">
                            News
                          </div>
                          <div className="title">
                            {title}
                          </div>
                          <div className="description">
                            <p className='publicDate'><b>Publication date: </b>{publicationDate}</p>

                            {introduction.length <= 230 ? (
                              <p>{introduction}</p>
                            ) : (
                              <div>
                                <p>{introduction.substring(0, this.getCaracteresCuerpoPrincipal({title},false))}...</p>
                                <a href="./news">Read more</a>
                              </div>
                            )}


                          </div>

                        </div>
                      </a>
                    );
                  })
                    : ''}
                  {type === 'pressNotes' ? data.map(({ title, introduction, link, publicationDate }) => {
                    return (
                      <a href='./press-notes' style={{ textDecoration: 'none' }} >
                        <div className='tablon-card' on >
                          <div className="tipo pressNotes">
                            Press Release
                          </div>
                          <div className="title">
                            {title}
                          </div>
                          <div className="description">
                            <p className='publicDate'><b>Publication date: </b>{publicationDate}</p>
                            {introduction.length <= 230 ? (
                              <p>{introduction}</p>
                            ) : (
                              <div>
                                <p>{introduction.substring(0, this.getCaracteresCuerpoPrincipal({title},false))}...</p>
                                <a href="./press-notes">Read more</a>
                              </div>
                            )}

                          </div>
                        </div>
                      </a>
                    );
                  })
                    : ''}
                  {type === 'events' ? data.map(({ title, eventDate, introduction, link, publicationDate }) => {
                    return (
                      <a href='./events' style={{ textDecoration: 'none' }} >
                        <div className='tablon-card' on>
                          <div className="tipo event">
                            Event
                          </div>
                          <div className="title">
                            {title}
                          </div>
                          <div className="description">
                            <p className='publicDate'><b>Publication date: </b>{publicationDate}</p>
                            <p><b>Fecha del vento: </b>{eventDate}</p>
                            {introduction.length <= 130 ? (
                              <p>{introduction}</p>
                            ) : (
                              <div>
                                <p>{introduction.substring(0, this.getCaracteresCuerpoPrincipal({title}, true))}...</p>
                                <a href="./events">Read more</a>
                              </div>
                            )}
                          </div>

                        </div>
                      </a>
                    );
                  })
                    : ''}
                  {type === 'offers' ? data.map(({ title, limitDate, description, link, publicationDate }) => {
                    return (
                      <a href='./offers' style={{ textDecoration: 'none' }} >
                        <div className='tablon-card' on >
                          <div className="tipo offer">
                            Offer
                          </div>
                          <div className="title">
                            {title}
                          </div>
                          <div className="description">
                            <p className='publicDate'><b>Publication date: </b>{publicationDate}</p>

                            <p><b>Fecha limite: </b>{limitDate}</p>
                            {description.length <= 130 ? (
                              <p>{description}</p>
                            ) : (
                              <div>
                                <p>{description.substring(0, this.getCaracteresCuerpoPrincipal({title}, true))}...</p>
                                <a href="./offers">Read more</a>
                              </div>
                            )}
                          </div>

                        </div>
                      </a>
                    );
                  })
                    : ''}

                </div>
              );

            })}
          </div>
        }
      </div>
    );
  }
}

export default NewsBoard;
